import { Subscribable } from 'rxjs';

export function isSubscribable(value: unknown): value is Subscribable<unknown> {
  return typeof value === 'object'
    && value !== null
    && typeof (value as { subscribe: unknown }).subscribe === 'function';
}
